import script from "./ProductFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFiles.vue?vue&type=script&setup=true&lang=js"

import "./ProductFiles.vue?vue&type=style&index=0&id=ff1e3084&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff1e3084"]])

export default __exports__